import { render, staticRenderFns } from "./expMarket2.vue?vue&type=template&id=1ef62288&scoped=true&"
import script from "./expMarket2.vue?vue&type=script&lang=js&"
export * from "./expMarket2.vue?vue&type=script&lang=js&"
import style0 from "./expMarket2.vue?vue&type=style&index=0&id=1ef62288&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef62288",
  null
  
)

export default component.exports